<template>
  <div>MAIN PAGE CONTENT</div>
</template>

<script>
export default {
  name:       "pageMain",
  components: {},

  data() {
    return {};
  },

  created() {
    this.$root.pageTitle = "Main Page";
  },

  methods: {},

  computed: {
  }
};
</script>

<style scoped>
</style>